<template>
  <div class="home" ref="scrollContainer">
    <Header :scrollTop="scrollTop" />
    <Home />
    <Node />
    <Record />
    <Share />
    <FQ />
    <Foot />
  </div>
</template>

<script>
import Header from '@/components/header/index.vue'
import Home from '@/components/home/index.vue';
import Node from '@/components/node/index.vue';
import Record from '@/components/record/index.vue';
import Share from '@/components/share/index.vue';
import FQ from '@/components/fq/index.vue';
import Foot from '@/components/foot/index.vue';

export default {
  name: 'HomeView',
  components: {
    Header, Home, Node, Record, Share, FQ, Foot
  },
  mounted() {
    this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll);
    if (window.location.href.includes('inviterAddress%')) {
      let href = window.location.href
      const _inviter = href.substring(href.length - 42, href.length)
      this.$store.state.urlInviterAddress = _inviter
    } else if (window.location.href.includes('inviterAddress')) {
      this.$store.state.urlInviterAddress = this.getParameterByName('inviterAddress')
    } else {
      this.$store.state.urlInviterAddress = ''
    }
  },
  beforeDestroy() {
    this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      scrollTop: 0
    }
  },
  methods: {
    handleScroll() {
      this.scrollTop = this.$refs.scrollContainer.scrollTop; // 更新滚动位置数据
    },
    getParameterByName(name, url = window.location.href) {
      name = name.replace(/[$\]]/g, '\\$&');
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
}
</script>

<style>
.home {
  overflow-y: scroll;
  height: 100vh;
  width: 100vw;
}

::-webkit-scrollbar {
  background-color: #fff !important;
  width: 8px !important;
  height: 8px;
}

::-webkit-scrollbar-track {
  background-color: #fff !important;
  width: 8px !important;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(#c9a962, #8b7355);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(#d4b872, #c9a962);
}

::selection {
  color: #fff;
  background: #c9a9624d
}

@media screen and (max-width: 500px) {
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
